<template>
  <div class="relative flex items-start">
    <div class="flex h-6 items-center">
      <input
        :id="editMode ? item.key : item.key + '_view'"
        :aria-describedby="`${item.label}-description`"
        :name="item.key"
        v-model="item.data"
        :disabled="disabled"
        @change="customChange"
        type="checkbox"
        class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
      />
    </div>
    <div class="ml-3 text-sm leading-6">
      <label :for="item.key" class="mt-1 text-sm text-gray-900">
        {{ item.label.split(".", 1)[0] }}
      </label>
    </div>
  </div>
  <div v-if="props.editMode">
    <div class="bg-white rounded-md my-2" :id="'outer-error_' + model.key">
      <p class="font-medium text-sm text-red-2" :id="'error_' + model.key"></p>
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps, ref } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { DynamicProperty } from "@/models/dtos";

const emit = defineEmits(["change"]);
const props = defineProps({
  model: {
    type: DynamicProperty,
    required: true,
  },
  id: String,
  label: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    required: false,
    type: Boolean,
  },
});
let item = ref(props.model);

function customChange() {
  emit("change", item.value);
}
</script>
